import { render, staticRenderFns } from "./FormTwo.vue?vue&type=template&id=37e8905a&scoped=true"
import script from "./FormTwo.vue?vue&type=script&lang=js"
export * from "./FormTwo.vue?vue&type=script&lang=js"
import style0 from "./FormTwo.vue?vue&type=style&index=0&id=37e8905a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8905a",
  null
  
)

export default component.exports